const NAMESPACES = {
  mobile: 'Mobile',
  pages: 'Pages',
  api: 'API',
  chat: 'Chat',
  bot: 'Bot',
  feedback: 'Feedback',
  language: 'Language',
} as const;

// eslint-disable-next-line import/prefer-default-export
export { NAMESPACES };
